import React from 'react';
import { Link } from "react-router-dom";
import Message from '../../components/message/index';
import CommonBtn from '../../components/btn/index';
import http from '../../http/http';
import { connect } from 'react-redux';
import global from '../../http/common';
import { Avatar, Dropdown, Menu } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './index.css';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ariaExpanded: false,
      messageShow: false,
      messageText: "",
      messageId: "",
      userInfo: {},
      collapseHeight: 240
    }
  }
  componentDidMount () {
    if (!this.props.close_header_message) {
      this.props.CLOSE_HEADER_MESSAGE(true);
      if (!this.props.header_message_data || !Object.keys(this.props.header_message_data).length) {
        http.get("/public/api/news/list", {
          topFlag: true
        }, response => {
          if (response && response.result && response.result.data) {
            let dataArr = response.result.data;
            console.log(dataArr);
            let map = dataArr[0];
            this.props.SAVE_HEADER_MESSAGE_DATA(map);
            let content = map.title;
            let id = map.id;
            if (content) {
              this.setState({
                messageShow: true,
                messageText: content,
                messageId: id
              });
              this.props.CLOSE_HEADER_MESSAGE(false);
            }
          }
        });
      } else {
        let content = this.props.header_message_data.title;
        let id = this.props.header_message_data.id;
        if (!content) {
          content = "";
        }
        this.setState({
          messageShow: true,
          messageText: content,
          messageId: id
        });
        this.props.CLOSE_HEADER_MESSAGE(false);
      }
    }

    // sessionStorage.setItem("token", "ebaf6808-b452-46d6-b2c7-028cd29509aa");
    // global.setCookie("test", "111");
    // global.clearAllCookie();
    var isLogin = global.isLogin();
    if (isLogin) {
      if (!this.props.user_info_data || !Object.keys(this.props.user_info_data).length) {
        //获取用户信息
        http.get("/access/api/user", {}, response => {
          console.log(response);
          if (response && response.result) {
            this.props.SAVE_USER_INFO_DATA(response.result);
            this.setState({
              userInfo: response.result
            });
          }
        });
      } else {
        this.setState({
          userInfo: this.props.user_info_data
        });
      }
    }
  }
  render () {
    let userDrowDownMenu = (
      <div className="userDrowDownMenu">
        <div className="userDrowMenuItem_header">
          <UserOutlined style={{ display: this.state.userInfo.headIconUri && this.state.userInfo.headIconUri != "" ? "none" : "block" }} />
          <img className="userIcon" style={{ display: this.state.userInfo.headIconUri && this.state.userInfo.headIconUri != "" ? "block" : "none" }} src={http.hostUrl + http.contextName + this.state.userInfo.headIconUri}></img>
          <span style={{ marginLeft: "10px" }}>{this.state.userInfo.nickName}</span>
        </div>
        <Menu onClick={this.userDrowDownMenuCLick.bind(this)} style={{ background: "rgb(250,250,250)", border: "none" }}>
          <Menu.Item key="1">
            <div className="userDrowMenuItem">进入工作区</div>
          </Menu.Item>
          <Menu.Item key="2">
            <div className="userDrowMenuItem">退出登录</div>
          </Menu.Item>
        </Menu>
      </div>
    );
    let userIcon = null;
    if (this.state.userInfo.headIconUri && this.state.userInfo.headIconUri != "") {
      userIcon = <img src={http.hostUrl + http.contextName + this.state.userInfo.headIconUri}></img>
    } else {
      userIcon = <UserOutlined />
    }
    return (
      <div className="app_header" style={this.props.newStyle}>
        <Message text={this.state.messageText} id={this.state.messageId} show={this.state.messageShow}></Message>
        <div className='home_header box-padding-horizontal' style={{ background: this.props.background ? this.props.background : "var(--thin_bg_color)" }}>
          <div className='logo'>
            <div style={{ position: "relative" }}>
              <Link className="link" to="/"></Link>
              赛百UI
            </div>
            <div className="version">
              <div>1.0.0</div>
            </div>
            <div className="old_item_line"></div>
            <div className="old_item" onClick={this.goOldSystem.bind(this)}>旧系统入口</div>
          </div>
          <div className='menu'>
            <div className="pc-menu pc-show">
              <ul className="pc-menu-ul">
                <li className={this.props.index == 0 ? "active pc-menu-li" : "pc-menu-li"}>
                  <Link className="link" to="/"></Link>
                  <div className="header_text">首页</div>
                  <div className="bottom-line">
                  </div>
                </li>
                <li className={this.props.index == 1 ? "active pc-menu-li" : "pc-menu-li"} >
                  <Link className="link" to="/words/从这里开始"></Link>
                  <div className="header_text">文档</div>
                  <div className="bottom-line">
                  </div>
                </li>
                <li className={this.props.index == 2 ? "active pc-menu-li" : "pc-menu-li"} >
                  <Link className="link" to="/case"></Link>
                  <div className="header_text">案例</div>
                  <div className="bottom-line">
                  </div>
                </li>
                <li className={this.props.index == 3 ? "active pc-menu-li" : "pc-menu-li"}>
                  <Link className="link" to="/trends"></Link>
                  <div className="header_text">动态</div>
                  <div className="bottom-line">
                  </div>
                </li>
              </ul>
              <CommonBtn type="common" text="免注册登录" newStyle={{ background: "rgba(200, 200, 200, 0.5)", color: "white", height: "30px", lineHeight: "30px", width: "100px", marginLeft: "60px", display: Object.keys(this.state.userInfo).length ? "none" : "block" }} btnClick={this.loginBtnClick.bind(this)}></CommonBtn>
              <Dropdown overlay={userDrowDownMenu} placement="bottomRight">
                <Avatar className="header_menu_right header_login_user" style={{ backgroundColor: "transparent", marginLeft: "40px", border: !this.state.userInfo.headIconUri ? "1px solid white" : "none", cursor: "pointer", display: Object.keys(this.state.userInfo).length ? "block" : "none" }} size={32} gap={0} icon={
                  userIcon
                } />
              </Dropdown>
            </div>
            <div className="mobile-menu mobile-show">
              <div className="mobile-menu-button" aria-expanded={this.state.ariaExpanded ? "true" : "false"} onClick={this.mobileButtonClick.bind(this)}>
                <span className="mobile-menu-button-line"></span>
                <span className="mobile-menu-button-line"></span>
                <span className="mobile-menu-button-line"></span>
              </div>
            </div>
          </div>
          <div className="mobile-menu-collapse box-padding-horizontal" style={{ height: this.state.ariaExpanded ? this.state.collapseHeight + "px" : "0px" }}>
            <ul className="mobile-menu-ul">
              <li className={this.props.index == 0 ? "active mobile-menu-li" : "mobile-menu-li"}>
                <Link className="link" to="/"></Link>
                <div className="header_text">首页</div>
                <div className="mobile-bottom-line">
                </div>
              </li>
              <li className={this.props.index == 1 ? "active mobile-menu-li" : "mobile-menu-li"} >
                <Link className="link" to="/words/从这里开始"></Link>
                <div className="header_text">文档</div>
                <div className="mobile-bottom-line">
                </div>
              </li>
              <li className={this.props.index == 2 ? "active mobile-menu-li" : "mobile-menu-li"}>
                <Link className="link" to="/case"></Link>
                <div className="header_text">案例</div>
                <div className="mobile-bottom-line">
                </div>
              </li>
              <li className={this.props.index == 3 ? "active mobile-menu-li" : "mobile-menu-li"}>
                <Link className="link" to="/trends"></Link>
                <div className="header_text">动态</div>
                <div className="mobile-bottom-line">
                </div>
              </li>
            </ul>
            <div className="bottom">
              <CommonBtn type="common" text="免注册登录" newStyle={{ background: "var(--blue_highlight_color)", color: "white", height: "35px", lineHeight: "35px", width: "80%", display: Object.keys(this.state.userInfo).length || global.isPhone() ? "none" : "block" }} btnClick={this.loginBtnClick.bind(this)}></CommonBtn>
              <div className="user" style={{ display: Object.keys(this.state.userInfo).length ? "flex" : "none" }}>
                <Avatar className="header_menu_right header_login_user" style={{ backgroundColor: "transparent", marginLeft: "10px", border: "1px solid white", cursor: "pointer" }} size={24} gap={0} icon={<UserOutlined />} />
                <div className="user_name">{this.state.userInfo.nickName}</div>
                <div className="user_btn" onClick={this.userDrowDownMenuCLick.bind(this, { key: 1 })} > 我的设计 >></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  loginBtnClick () {
    if (this.props.index) {
      window.loginBtnClick();
    } else {
      window.loginBtnClick("refresh");//不跳转
    }
  }
  mobileButtonClick () {
    this.setState({
      ariaExpanded: !this.state.ariaExpanded
    })
  }
  userDrowDownMenuCLick (e) {
    if (e.key == "1") {
      window.hrefProductHome();
    } else if (e.key == "2") {
      //退出登录
      window.sessionStorage.clear();
      global.clearAllCookie();
      this.setState({
        userInfo: {}
      });
      this.props.SAVE_USER_INFO_DATA({});
      let timer = setTimeout(() => {
        clearTimeout(timer);
        window.location.reload();
      }, 1000);
    }
  }
  goOldSystem () {
    window.location.href = "https://cyberui.cn/t_i/pages/home.html";
  }
}

function mapStateToProps (state) {
  return {
    close_header_message: state.close_header_message,
    header_message_data: state.header_message_data,
    user_info_data: state.user_info_data
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    CLOSE_HEADER_MESSAGE: (bool) => {
      dispatch({ type: 'CLOSE_HEADER_MESSAGE', close_header_message: bool })
    },
    SAVE_HEADER_MESSAGE_DATA: (map) => {
      dispatch({ type: 'SAVE_HEADER_MESSAGE_DATA', header_message_data: map })
    },
    SAVE_USER_INFO_DATA: (map) => {
      dispatch({ type: 'SAVE_USER_INFO_DATA', user_info_data: map })
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Header);